import {
  TELEHUSET_CUSTOMER_ID,
  SKYTECH_CUSTOMER_ID,
  INTUNOR_CUSTOMER_IDS,
  KPMG_CUSTOMER_HEAD_ID,
  MULTI_CONSULT_CUSTOMER_HEAD_ID,
} from '@skytech/utils/constants'
import { useQuery } from '@tanstack/react-query'

import queries from '@/api/queries'
import statusResources from '@/api/status'
import userResources from '@/api/user'
import { useAppContext } from '@/App.context'

const useUser = () =>
  useQuery(queries.status(), statusResources.get, {
    staleTime: Infinity,
  }).data?.object

export default useUser

export const useIsIntunor = () => {
  const user = useUser()

  if (!user) return false

  return INTUNOR_CUSTOMER_IDS.includes(user.customerId)
}

export const useIsKPMG = () => {
  const user = useUser()

  if (!user) return false

  return KPMG_CUSTOMER_HEAD_ID === user.customerHeadId
}

export const useIsSkytech = () => {
  const user = useUser()

  if (!user) return false

  return user.customerId === SKYTECH_CUSTOMER_ID
}

export const useIsTelehuset = () => {
  const user = useUser()

  if (!user) return false

  return user.customerId === TELEHUSET_CUSTOMER_ID
}

export const useIsMultiConsult = () => {
  const user = useUser()

  if (!user) return false

  return MULTI_CONSULT_CUSTOMER_HEAD_ID === user.customerHeadId
}

export const useEditTranslationsPrivilege = () => {
  const user = useQuery(queries.user(), userResources.get, {
    staleTime: Infinity,
  }).data

  if (!user) return 'CANNOT_EDIT'

  return user?.editTranslationsPrivilege
}

export const useIsThreeStepIT = () => {
  const { whiteLabel } = useAppContext()
  if (!whiteLabel) return false

  return whiteLabel === 'threeStepIT'
}
